var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "template-component" },
    [
      _c("div", { staticClass: "level" }, [
        _c("div", { staticClass: "level-left" }, [
          _c("div", { staticClass: "level-item" }, [
            _c(
              "div",
              { class: ["dropdown", { "is-active": _vm.isFilterActive }] },
              [
                _c("div", { staticClass: "dropdown-trigger" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      on: { click: _vm.toggleFilterDropdown },
                    },
                    [
                      _vm._m(0),
                      _c("span", [_vm._v("Filter")]),
                      _vm.selectedFilterTags.length
                        ? _c(
                            "span",
                            {
                              staticClass: "ml-2 tag",
                              class: `is-${_vm.$theme.name}`,
                              style: { borderRadius: "20px" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.selectedFilterTags.length) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
                _c("TagsDropdownMenu", {
                  attrs: {
                    tags: _vm.tags,
                    "selected-tags": _vm.selectedFilterTags,
                    "is-visible": _vm.isFilterActive,
                  },
                  on: {
                    "toggle-tag": _vm.toggleFilterTag,
                    "clear-all-tags": _vm.clearAllFilterTags,
                  },
                }),
              ],
              1
            ),
          ]),
          _vm.showManageTag
            ? _c("div", { staticClass: "level-item" }, [
                _c(
                  "button",
                  {
                    staticClass: "button",
                    on: { click: _vm.toggleManageTagsModal },
                  },
                  [_vm._v("Manage Tags")]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm.templatesLoading
        ? _c(
            "div",
            { staticStyle: { position: "relative", top: "100px" } },
            [_c("spinner")],
            1
          )
        : _vm._e(),
      _vm.templates.length === 0 && !_vm.templatesLoading
        ? _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "is-flex py-4 m-1 is-justify-content-center is-align-items-center has-text-grey",
              },
              [
                _c("div", [
                  _vm._m(1),
                  !!_vm.permussions?.hasAdd
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "is-flex is-align-items-center is-justify-content-center is-flex-direction-column has-text-centered",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "No templates yet for this vehicle type, but you can create one!"
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              "Just add items to your quote, click More options (top right),"
                            ),
                          ]),
                          _c("span", [
                            _vm._v("and select Save Template for future use."),
                          ]),
                        ]
                      )
                    : _c(
                        "span",
                        {
                          staticClass:
                            "is-flex is-align-items-center is-justify-content-center is-flex-direction-column has-text-centered",
                        },
                        [
                          _c("span", [_vm._v("No templates yet!")]),
                          _c("span", [
                            _vm._v(
                              "Please contact an admin or support staff to create one."
                            ),
                          ]),
                        ]
                      ),
                ]),
              ]
            ),
          ])
        : _c("div", [
            _c(
              "div",
              { staticClass: "templates-container" },
              [
                _vm.filteredTemplates.length === 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "has-text-grey-light is-flex is-flex-direction-column is-align-items-center",
                      },
                      [
                        _vm._m(2),
                        _c("span", { staticClass: "mt-3 pt-3" }, [
                          _vm._v("No results found"),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._l(_vm.filteredTemplates, function (i) {
                  return _c(
                    "div",
                    {
                      key: i.templateId,
                      staticClass:
                        "is-flex p-1 m-1 is-justify-content-space-between is-align-items-center template-list-item",
                      class: `quote-builder-template-item-${_vm.$theme.name}`,
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "is-flex",
                          staticStyle: { flex: "1", "min-width": "0" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "ml-2",
                              staticStyle: { "min-width": "fit-content" },
                            },
                            [_vm._v(_vm._s(i.name))]
                          ),
                          _c(
                            "div",
                            { staticClass: "tags-container ml-2" },
                            _vm._l(_vm.getSortedTags(i.tags), function (tag) {
                              return _c(
                                "span",
                                {
                                  key: tag.tagID,
                                  staticClass: "tag is-light",
                                  style: {
                                    backgroundColor: tag.colorHex,
                                    color: _vm.getTextColor(tag.colorHex),
                                    borderRadius: "9999px",
                                    fontWeight: "bold",
                                  },
                                },
                                [_vm._v(" " + _vm._s(tag.shortTag) + " ")]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "is-flex is-align-items-center py-1" },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "button is-ghost is-small tooltip p-0 has-text-primary is-clickable mr-2",
                              attrs: { "data-tooltip": "View and Add Items" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleTemplateClick(i)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "material-symbols-outlined" },
                                [_vm._v("add")]
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass:
                                "button is-ghost is-small tooltip px-0 mr-1 has-text-grey-lighter",
                              staticStyle: {
                                border: "none",
                                height: "auto",
                                background: "transparent",
                              },
                              attrs: {
                                disabled: !_vm.permussions?.hasDelete,
                                "data-tooltip": "Delete",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDeleteTemplateClick(i)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "material-symbols-rounded",
                                  on: {
                                    mouseenter: function ($event) {
                                      return $event.target.classList.add(
                                        "has-text-danger"
                                      )
                                    },
                                    mouseleave: function ($event) {
                                      return $event.target.classList.remove(
                                        "has-text-danger"
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" delete ")]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ]),
      _vm.templateDeleted
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.deleteTemplate(true)
                },
                cancel: function ($event) {
                  return _vm.deleteTemplate(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Delete Quote Template"),
              ]),
              _c(
                "p",
                {
                  staticClass: "has-text-danger",
                  attrs: { slot: "text-content" },
                  slot: "text-content",
                },
                [
                  _vm._v(" Quote Template "),
                  _c("span", { staticClass: "has-text-weight-bold" }, [
                    _vm._v(_vm._s(_vm.templateDeleted.name)),
                  ]),
                  _vm._v(" will be deleted. Continue? "),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.templateToAdd
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.addTemplateConfirmModalActive,
                "ok-text": "Ok",
                "cancel-text": "Cancel",
              },
              on: {
                "update:active": function ($event) {
                  _vm.addTemplateConfirmModalActive = $event
                },
                ok: _vm.addItemsFromTemplate,
                cancel: _vm.cancelAddItems,
              },
            },
            [
              _c(
                "p",
                {
                  staticClass: "has-text-weight-semibold",
                  attrs: { slot: "text-title" },
                  slot: "text-title",
                },
                [_vm._v("Add Items from: " + _vm._s(_vm.templateToAdd.name))]
              ),
              _c(
                "div",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c("p", [
                    _vm._v(
                      "You are about to import " +
                        _vm._s(_vm.templateItems?.length) +
                        " items into Quote " +
                        _vm._s(_vm.quoteNo) +
                        "."
                    ),
                  ]),
                  _c("p", { staticClass: "mt-2" }, [
                    _vm._v("Press OK to confirm or Cancel to go back."),
                  ]),
                  _c("p", { staticClass: "mt-3 is-size-6 has-text-grey" }, [
                    _c("span", { staticClass: "has-text-weight-semibold" }, [
                      _vm._v("Note:"),
                    ]),
                    _vm._v(" This action cannot be undone. "),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.isTemplateItemsModalActive
        ? _c("template-items-modal", {
            attrs: {
              active: _vm.isTemplateItemsModalActive,
              "selected-template": _vm.selectedTemplate,
              tags: _vm.tags,
              rates: _vm.rates,
            },
            on: {
              "update:active": function ($event) {
                _vm.isTemplateItemsModalActive = $event
              },
              addTemplateItemsCustom: (obj) =>
                _vm.$emit("addTemplateItemsCustom", obj),
            },
          })
        : _vm._e(),
      _vm.showManageTag
        ? _c("manage-tags-modal", {
            attrs: {
              active: _vm.showManageTagsModal,
              tags: _vm.tags,
              "tag-category-id": _vm.tagCategoryId,
            },
            on: {
              close: function ($event) {
                _vm.showManageTagsModal = false
              },
              save: _vm.handleSaveTags,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "is-flex is-justify-content-center my-2 has-text-grey-lighter",
      },
      [
        _c("span", { staticClass: "material-symbols-rounded is-size-1" }, [
          _vm._v(" note_add "),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-feature-search-outline mdi-56px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }